import React from 'react'
import Backdrop from '@mui/material/Backdrop';
import logo from "../../assets/gif/white 1.gif";
export const Spinner = () => {
    return (
        <div style={{ zIndex: 30000000001 }}>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1100011111111111 }} open>
                <img src={logo} alt="" width={200} />
            </Backdrop>
        </div>
    )
}
